import { Tree } from "@renderbus/ui";
import styled from "styled-components";
import { IDingTalkOrganization } from "../child-integration-setting/hooks/useChildIntergrationSettingInfo";
import {
  IdeptInfo,
  useDingTalkSubAccountStore,
} from "../../store/dingtalk-subaccount-store";
import React, { useEffect, useState } from "react";
import { useSubAccountStore } from "@/store/SubAccountStore";

export function ChildManageTree({
  dataSource = [],
  isImportTree = false,
}: {
  dataSource?: IdeptInfo[] | IDingTalkOrganization[];
  isImportTree?: boolean;
}) {
  const { fetchDingTalkSubAccountList } = useSubAccountStore();
  const {
    checkTreeKeys,
    setCheckTreeKeys,
    isAutoExpandParent,
    setIsAutoExpandParent,
    setExpandedDeptyKeys,
    expandeDeptyKeys,
    setCheckTreeInfo,
    isSearchExpandKey,
    selectTreeKey,
  } = useDingTalkSubAccountStore();
  const [selectTreeKeys, setSelectTreeKeys] = useState<React.Key[]>([]);

  const onSelect = (
    keys: any,
    e: { selected: any; node: { key: any; deptId: any } }
  ) => {
    if (!e.selected) {
      // @ts-ignore
      setSelectTreeKeys([e.node.key]);
      // return;
    } else {
      setSelectTreeKeys(keys);
    }
    fetchDingTalkSubAccountList({ deptId: e.node.deptId });
  };

  const onCheck = (checkedKeysValue: React.Key[], info: any) => {
    setCheckTreeKeys(checkedKeysValue);
    setCheckTreeInfo(info.checkedNodes);
  };

  useEffect(() => {
    if (isSearchExpandKey) return;
    setSelectTreeKeys(expandeDeptyKeys);
  }, [expandeDeptyKeys, isSearchExpandKey]);

  useEffect(() => {
    if (selectTreeKey) {
      setSelectTreeKeys([selectTreeKey]);
    }
  }, [selectTreeKey]);

  return (
    <TreeWrapper>
      <Tree
        checkable
        className={"dingtalk-init-tree"}
        onExpand={(expandKey: React.Key[]) => {
          setIsAutoExpandParent(false);
          setExpandedDeptyKeys(expandKey);
        }}
        expandedKeys={expandeDeptyKeys}
        checkedKeys={checkTreeKeys}
        // 设置autoExpandParent为了解决动态树初始化页面时子节点不展开的问题（但是设置autoExpandParent会影响节点展开和收合的交互，慎用）
        autoExpandParent={isAutoExpandParent}
        selectedKeys={selectTreeKeys}
        // @ts-ignore
        onCheck={(checkedKeysValue: React.Key[], info: any) =>
          onCheck(checkedKeysValue, info)
        }
        onSelect={(checkedKeysValue: React.Key[], info: any) =>
          onSelect(checkedKeysValue, info)
        }
        // @ts-ignore
        treeData={dataSource}
        fieldNames={{
          title: "name",
          key: "keyIndex",
          children: "deptList",
        }}
      />
    </TreeWrapper>
  );
}

const TreeWrapper = styled.div`
  padding: 6px 0;
`;
